<template>
    <b-table
        hover
        dark
        :fields="positionFields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="positions"
        thead-class="hide_header"
        class="m-0"
    >
        <template v-slot:cell(ticker)="data">
            <router-link
                class="security_symbol" :class="securityClasses(data.item)"
                :to="{ name: 'asset', params: { symbol: data.item.ticker, pid: data.item.pid } }"
            >{{ data.item.ticker }}</router-link>
        </template>

        <template v-slot:cell(positionSize)="data">
            <strong>${{ data.item.size }}</strong>
            <br />
            <small>{{ data.item.shares }}</small>
        </template>

        <template v-slot:cell(openPrice)="data">
            <strong>${{ data.item.open_price }}</strong> &#x21E2;
            <br />
            <small>{{ data.item.open_date }}</small>
        </template>

        <template v-slot:cell(closePrice)="data">
            <strong>${{ data.item.close_price }}</strong>
            <br />
            <b-button
                v-if="activeButtonSet.has(data.item.pid)"
                variant="success"
                size="sm"
                href="#app" 
                @click.prevent="$emit('reinvest', data.item.pid)"
                >Reinvest</b-button>
            <b-spinner
                v-else
                small
                type="grow" 
                class="button_spinner mx-3"
                variant="success"
            ></b-spinner>
        </template>

        <template v-slot:cell(currentPrice)="data">
            <strong>${{ formatPrice(data.item.current_price) }}</strong>
            <br />
            <b-badge v-if="data.item.indicator > 0" variant="dark">{{ data.item.indicator }}%</b-badge>
            <b-badge v-else variant="warning">{{ data.item.indicator }}%</b-badge>
        </template>
    </b-table>
</template>

<script>
import formatterMixin from '../../mixins/formatter.js';

export default {
    name: 'StalePositionsTable',
    mixins: [formatterMixin],
    props: {
        positions: {
            type: Array,
            required: true
        },
        activeButtons: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            sortBy: "open_date",
            sortDesc: false,
            positionFields: [
                { key: "ticker", label: "" },
                { key: "positionSize", label: "Amount" },
                { key: "openPrice", label: "Open" },
                { key: "closePrice", label: "Close" },
                { key: "currentPrice", label: "Current" },
            ],
        }
    },
    computed: {
        // a filtered asset can render 1000+ rows; Array.includes per row is O(n²)
        activeButtonSet() {
            return new Set(this.activeButtons);
        },
    },
    methods: {
        securityClasses(item) {
            if (item.market === 'crypto') return 'symbol_color_crypto';
            return '';
        },
    }
}
</script>

<style>
.hide_header {
    display: none;
}
.symbol_color_crypto, .symbol_color_crypto:hover { 
    color: #e83e8c; 
}
</style>